/**
 * SEC-F02 (Phase 28 3-I) — defang API error strings before they
 * land in user-facing UI copy.
 *
 * Backend 500 / 4xx responses often carry ``detail`` strings with
 * internal paths, SQL fragments, LLM provider error bodies, or
 * model names. Rendering them verbatim in the UI leaks
 * implementation details to anyone who triggers an error.
 *
 * Pass-through policy: a short, plain-text message with no path
 * separators and no "Traceback" marker is treated as a
 * deliberate user-facing string (e.g. the validator-built
 * "Matter belongs to a different workspace; switch context"
 * copy). Anything else collapses to a generic message — the raw
 * value is preserved for developers via a dev-mode console.error
 * at the call site (per the brief's pattern).
 */

const _PASS_THROUGH_MAX_LEN = 200;
const _LEAKY_TOKENS = ['/', '\\', 'Traceback', 'at line ', 'File "'];

export function sanitizeApiError(raw: unknown): string {
  if (typeof raw !== 'string' || !raw.trim()) {
    return 'An unexpected error occurred.';
  }
  const trimmed = raw.trim();
  // Heuristic pass-through: short text, no path separators, no
  // stack-frame markers, no obvious leak signatures.
  if (
    trimmed.length < _PASS_THROUGH_MAX_LEN
    && !_LEAKY_TOKENS.some((tok) => trimmed.includes(tok))
  ) {
    return trimmed;
  }
  return 'An error occurred. Please try again or contact support.';
}
